export const dateFormatHHMM = (date: Date) =>
    `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
